import axios from "axios";
import apiConfig from './api.config';
class PDIDataService {
    getAll() {
        return axios.get(`/item-pdis?populate=*`, apiConfig.connData());
    }
    get(id) {
        return axios.get(`/item-pdis/${id}?populate=*`, apiConfig.connData());
    }
}
export default new PDIDataService();

